/**
@ngdoc directive
@name formInvalidMessage

@description
Error message for invalid form. Please place in the top of the form.
*/
(function() {

    var formInvalidMessage = function() {
        return {
            restrict: "EA",
            replace: false,
            template: '<p ng-if="form.$invalid && form.$submitted" class="alert alert-danger" ng-transclude role="alert" aria-live="assertive"></p>',
            transclude: true,
            require: '^form', // parent form binding
            link: function(scope, element, attrs, formCtrl) {
                scope.form = formCtrl; // parent form binding
            }
        };
    }
    angular.module('app').directive('formInvalidMessage', formInvalidMessage);

}());